import {WallabyColors, ColorsPalette} from '@wallaby-ui/core';

export type HaidiColors = WallabyColors;

export const red: ColorsPalette = {
  50: '#FFF1F1',
  100: '#FFD7D9',
  200: '#FFB3B8',
  300: '#FF8389',
  400: '#FA4D56',
  500: '#DA1E28',
  600: '#A2191F',
  700: '#750E13',
  800: '#520408',
  900: '#2D0709',
};

export const purple: ColorsPalette = {
  50: '#F6F2FF',
  100: '#E8DAFF',
  200: '#D4BBFF',
  300: '#BE95FF',
  400: '#A56EFF',
  500: '#8A3FFC',
  600: '#6929C4',
  700: '#491D8B',
  800: '#31135E',
  900: '#1C0F30',
};

export const haidiBlue: ColorsPalette = {
  50: '#D8E8FF',
  100: '#D8E8FF',
  200: '#D8E8FF',
  300: '#6FA9FF',
  400: '#6FA9FF',
  500: '#154fa6',
  600: '#05357B',
  700: '#10264C',
  800: '#10264C',
  900: '#02050A',
};

export const haidiCoolGray: ColorsPalette = {
  50: '#F4F6FA',
  100: '#F4F6FA',
  200: '#F4F6FA',
  300: '#E2E8F2',
  400: '#E2E8F2',
  500: '#9BA8BD',
  600: '#9BA8BD',
  700: '#5D6F88',
  800: '#5D6F88',
  900: '#5D6F88',
};

export const merieMetallicSeaweed: ColorsPalette = {
  50: '#DEF9FF',
  100: '#91EEFF',
  200: '#16DAEF',
  300: '#11B9CC',
  400: '#0C9BAB',
  500: '#087E8B',
  600: '#045B65',
  700: '#024047',
  800: '#012B30',
  900: '#00191D',
};

export const merieCoolGray: ColorsPalette = {
  50: '#F2F4F8',
  100: '#DDE1E6',
  200: '#C1C7CD',
  300: '#A2A9B0',
  400: '#878D96',
  500: '#697077',
  600: '#4D5358',
  700: '#343A3F',
  800: '#21272A',
  900: '#121619',
};

export const white = '#FFFFFF';
export const black = '#000000';
export const canvasGray = '#E8EAEE';
